module.exports = __webpack_public_path__ + "img/icon-shots.68bd3b75.svg";